import { render, staticRenderFns } from "./alipayBind.vue?vue&type=template&id=6e08ea38&scoped=true&"
import script from "./alipayBind.vue?vue&type=script&lang=js&"
export * from "./alipayBind.vue?vue&type=script&lang=js&"
import style0 from "./alipayBind.vue?vue&type=style&index=0&id=6e08ea38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e08ea38",
  null
  
)

export default component.exports